/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './html-editor.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/metadata/view';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '../../../node_modules/@angular/common/src/directives/ng_style.ngfactory';
import * as import11 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import12 from '@angular/core/src/linker/element_ref';
import * as import13 from '@angular/common/src/directives/ng_style';
export class Wrapper_HtmlEditorComponent {
  context:import0.HtmlEditorComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  constructor() {
    this.changed = false;
    this.context = new import0.HtmlEditorComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  check_elementId(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.elementId = currValue;
      this._expr_0 = currValue;
    }
  }
  check_initText(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.initText = currValue;
      this._expr_1 = currValue;
    }
  }
  check_height(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.height = currValue;
      this._expr_2 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_HtmlEditorComponent_Host:import4.RenderComponentType = (null as any);
class _View_HtmlEditorComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _HtmlEditorComponent_0_4:Wrapper_HtmlEditorComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_HtmlEditorComponent_Host0,renderType_HtmlEditorComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'html-editor',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_HtmlEditorComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._HtmlEditorComponent_0_4 = new Wrapper_HtmlEditorComponent();
    this._appEl_0.initComponent(this._HtmlEditorComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._HtmlEditorComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.HtmlEditorComponent) && (0 === requestNodeIndex))) { return this._HtmlEditorComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._HtmlEditorComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._HtmlEditorComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HtmlEditorComponent_0_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._HtmlEditorComponent_0_4.context.ngOnDestroy();
  }
}
function viewFactory_HtmlEditorComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_HtmlEditorComponent_Host === (null as any))) { (renderType_HtmlEditorComponent_Host = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_HtmlEditorComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const HtmlEditorComponentNgFactory:import9.ComponentFactory<import0.HtmlEditorComponent> = new import9.ComponentFactory<import0.HtmlEditorComponent>('html-editor',viewFactory_HtmlEditorComponent_Host0,import0.HtmlEditorComponent);
const styles_HtmlEditorComponent:any[] = ([] as any[]);
var renderType_HtmlEditorComponent:import4.RenderComponentType = (null as any);
class _View_HtmlEditorComponent0 extends import3.AppView<import0.HtmlEditorComponent> {
  _el_0:any;
  _NgStyle_0_3:import10.Wrapper_NgStyle;
  _text_1:any;
  /*private*/ _expr_3:any;
  _map_4:any;
  /*private*/ _expr_5:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_HtmlEditorComponent0,renderType_HtmlEditorComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_3 = import1.UNINITIALIZED;
    this._map_4 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'height.em': p0};
    });
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import2.createRenderElement(this.renderer,parentRenderNode,'textarea',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._NgStyle_0_3 = new import10.Wrapper_NgStyle(this.parentInjector.get(import11.KeyValueDiffers),new import12.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.NgStyle) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgStyle_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this._map_4(this.context.height);
    this._NgStyle_0_3.check_ngStyle(currVal_0_0_0,throwOnChange,false);
    this._NgStyle_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_3:any = import2.interpolate(1,'',this.context.elementId,'');
    if (import2.checkBinding(throwOnChange,this._expr_3,currVal_3)) {
      this.renderer.setElementProperty(this._el_0,'id',currVal_3);
      this._expr_3 = currVal_3;
    }
    this._NgStyle_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_5:any = import2.interpolate(1,'',this.context.initText,'');
    if (import2.checkBinding(throwOnChange,this._expr_5,currVal_5)) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_HtmlEditorComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.HtmlEditorComponent> {
  if ((renderType_HtmlEditorComponent === (null as any))) { (renderType_HtmlEditorComponent = viewUtils.createRenderComponentType('',0,import8.ViewEncapsulation.None,styles_HtmlEditorComponent,{})); }
  return new _View_HtmlEditorComponent0(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/html-editor.component.ngfactory.ts